module.exports = __webpack_public_path__ + "static/media/首页视频.569875a.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/首页视频.mp4
// module id = IF+G
// module chunks = 1